import { Link } from 'react-router-dom';
import { Container } from '@/components/Container';

/* ═══════════════════════════════════════════════════════════════
   PILARES — "Leia também" reformulado
   Aponta para as 3 páginas pilares (guias completos por categoria)
   em vez de posts de blog. Linkagem interna com âncoras de keyword.
   ═══════════════════════════════════════════════════════════════ */

const PILARES = [
  {
    to: '/praias-ilha-do-mel',
    emoji: '🏖️',
    titulo: 'Praias da Ilha do Mel',
    desc: 'O guia de todas as praias: mar calmo, surf, piscinas naturais e como chegar em cada uma.',
  },
  {
    to: '/pousadas-ilha-do-mel',
    emoji: '🏨',
    titulo: 'Pousadas na Ilha do Mel',
    desc: 'As melhores pousadas por vila e perfil — do econômico ao pé na areia — com comparativo e reservas.',
  },
  {
    to: '/restaurantes-ilha-do-mel',
    emoji: '🍽️',
    titulo: 'Restaurantes na Ilha do Mel',
    desc: 'Onde comer bem na ilha: frutos do mar, pé na areia e alta gastronomia, com dicas de cada vilarejo.',
  },
] as const;

export function PilaresSection() {
  return (
    <section className="py-16 sm:py-20 bg-sand-50">
      <Container>
        <div className="text-center mb-12">
          <span className="font-body text-sm text-coral font-semibold uppercase tracking-wider">
            Aprofunde
          </span>
          <h2 className="font-display text-4xl sm:text-5xl text-warm-dark mt-2">
            Guias completos da Ilha do Mel
          </h2>
          <p className="font-editorial text-lg text-warm-gray mt-2 max-w-2xl mx-auto">
            Mergulhe em cada categoria com nossos guias dedicados — atualizados e feitos por quem
            conhece a ilha.
          </p>
        </div>

        <div className="grid sm:grid-cols-3 gap-6">
          {PILARES.map(p => (
            <Link
              key={p.to}
              to={p.to}
              className="group block bg-white rounded-2xl border border-sand-200 p-6 shadow-[0_2px_12px_rgba(0,0,0,0.06)] transition-all hover:-translate-y-1 hover:shadow-lg"
            >
              <div className="text-4xl mb-4">{p.emoji}</div>
              <h3 className="font-display text-xl text-warm-dark group-hover:text-teal-deep transition-colors mb-2">
                {p.titulo}
              </h3>
              <p className="font-body text-sm text-warm-gray leading-relaxed mb-4">{p.desc}</p>
              <span className="inline-flex items-center gap-2 font-body text-sm font-semibold text-teal-deep">
                Ver guia
                <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </span>
            </Link>
          ))}
        </div>
      </Container>
    </section>
  );
}
